module.exports = __webpack_public_path__ + "static/media/country_mt.a63b8ae6.webp";